import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import watermark from 'watermark-dom';
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components';
import RightPanel from '@/components/RightPanel';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';
import _variables from '@/styles/variables.scss';
import signalRService from '@/utils/signalr';
export default {
  name: 'Layout',
  components: {
    AppMain: AppMain,
    Navbar: Navbar,
    RightPanel: RightPanel,
    Settings: Settings,
    Sidebar: Sidebar,
    TagsView: TagsView
  },
  mixins: [ResizeMixin],
  computed: _objectSpread(_objectSpread({}, mapState({
    theme: function theme(state) {
      return state.settings.theme;
    },
    sideTheme: function sideTheme(state) {
      return state.settings.sideTheme;
    },
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    variables: function variables() {
      return _variables;
    }
  }),
  mounted: function mounted() {
    watermark.load({
      watermark_txt: "".concat(this.$store.state.user.name).concat(this.$store.state.user.info.phone),
      watermark_angle: 35,
      watermark_fontsize: '16px',
      watermark_alpha: 0.06
    });
  },
  created: function created() {
    // 如果当前用户已登录，初始化 SignalR 连接
    if (this.$store.getters.token) {
      this.initSignalR();
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁前断开 SignalR 连接
    this.disconnectSignalR();
  },
  methods: {
    // 初始化 SignalR 连接
    initSignalR: function initSignalR() {
      var token = this.$store.getters.token;
      if (token) {
        signalRService.init(token);
      }
    },
    // 断开 SignalR 连接
    disconnectSignalR: function disconnectSignalR() {
      signalRService.stop();
    },
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    }
  }
};